import * as type from "./type";

const initialState = {
  list: [],
  
  vendors: [],
  totalRecords: 0,
  totalPages: 0,
  statusList: [],
  storeList: [],
  loading: false,
  
  sharing: false,
  shareResult: null,
  
  updating: false,
  updateResult: null,
  
  conversation: [],
  conversationTicketId: null,
  conversationLoading: false,

  ticketComments: [],
  ticketCommentsLoading: false,
};

const VendorSupportTicketsReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_VENDOR_SUPPORT_TICKETS_REQUEST:
      return { ...state, loading: true };
    case type.GET_VENDOR_SUPPORT_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload?.list || [],
        vendors: action.payload?.vendors || [],
        totalRecords: action.payload?.totalRecords || 0,
        totalPages: action.payload?.totalPages || 0,
      };
    case type.GET_VENDOR_TICKET_STATUS_SUCCESS:
      return { ...state, statusList: action.payload?.list || [] };
    case type.GET_VENDOR_TICKET_STORES_SUCCESS:
      return { ...state, storeList: action.payload?.list || [] };
    case type.GET_VENDOR_TICKET_CONVERSATION_REQUEST:
      return {
        ...state,
        conversationLoading: true,
        conversation: [],
        conversationTicketId: action.payload?.ticketId ?? null,
      };
    case type.GET_VENDOR_TICKET_CONVERSATION_SUCCESS:
      return {
        ...state,
        conversationLoading: false,
        conversation: action.payload?.list || [],
        conversationTicketId: action.payload?.ticketId ?? null,
      };
    case type.GET_VENDOR_TICKET_COMMENTS_REQUEST:
      return { ...state, ticketComments: [], ticketCommentsLoading: true };
    case type.GET_VENDOR_TICKET_COMMENTS_SUCCESS:
      return {
        ...state,
        ticketComments: action.payload?.list || [],
        ticketCommentsLoading: false,
      };
    case type.SHARE_VENDOR_TICKET_REQUEST:
      return { ...state, sharing: true, shareResult: null };
    case type.SHARE_VENDOR_TICKET_SUCCESS:
      return {
        ...state,
        sharing: false,
        shareResult: {
          status: true,
          message: action.payload?.message || "Ticket shared successfully",
          at: Date.now(),
        },
      };
    case type.SHARE_VENDOR_TICKET_FAILURE:
      return {
        ...state,
        sharing: false,
        shareResult: {
          status: false,
          message:
            action.payload?.message ||
            "Ticket could not be shared. Please try again",
          at: Date.now(),
        },
      };
    case type.UPDATE_VENDOR_TICKET_REQUEST:
      return { ...state, updating: true, updateResult: null };
    case type.UPDATE_VENDOR_TICKET_SUCCESS:
      return {
        ...state,
        updating: false,
        updateResult: {
          status: true,
          message: action.payload?.message || "Ticket updated successfully",
          at: Date.now(),
        },
      };
    case type.UPDATE_VENDOR_TICKET_FAILURE:
      return {
        ...state,
        updating: false,
        updateResult: {
          status: false,
          message:
            action.payload?.message ||
            "Ticket could not be updated. Please try again",
          at: Date.now(),
        },
      };
    default:
      return state;
  }
};

export default VendorSupportTicketsReducer;
